import { render, staticRenderFns } from "./OnboardingBusinessCard.vue?vue&type=template&id=831de9be&"
import script from "./OnboardingBusinessCard.vue?vue&type=script&lang=js&"
export * from "./OnboardingBusinessCard.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingBusinessCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports